export default __webpack_public_path__ + "static/media/66744afd-99d0-4790-bf4c-5712b05b98e8.93290879.woff";